"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCanonicalSearchUrl = void 0;

var _lodash = require("lodash");

var _index = require("./index");

var _constants = require("../constants");

var _parseTagsForUrl = function _parseTagsForUrl(tags) {
  var category;
  var format; // if tags is an array, take the first one that represents a category
  // if is an string, take it as is if it represents a category

  if (tags && (0, _lodash.isArray)(tags) && (0, _lodash.size)(tags)) {
    category = (0, _index.findTagByType)(_constants.CATEGORY_TAG_TYPE, tags);
    format = (0, _index.findTagByType)(_constants.FORMAT_TAG_TYPE, tags);
  } else if (tags && (0, _lodash.isString)(tags)) {
    category = tags.indexOf(_constants.CATEGORY_TAG_TYPE) > -1 ? tags : '';
    format = tags.indexOf(_constants.FORMAT_TAG_TYPE) > -1 ? tags : '';
  }

  return {
    category: category,
    format: format
  };
};

var _getDateForUrl = function _getDateForUrl(dates) {
  var date;

  if (dates && (0, _lodash.isArray)(dates) && (0, _lodash.size)(dates)) {
    date = (0, _lodash.last)(dates);
  } else if (dates && (0, _lodash.isString)(dates)) {
    date = dates;
  }

  return date;
};

var _formatNameForUrl = function _formatNameForUrl(name) {
  var parsedName = name || '';

  if (!(0, _lodash.isString)(parsedName)) {
    return parsedName;
  }

  parsedName = parsedName.trim().replace('.', '').replace(',', '').replace(' & ', ' and ');
  parsedName = parsedName.replace(/[ +,/]+/g, '-');
  return parsedName.toLowerCase();
};
/**
 * Given an object with all the search params, it will build the canonical ulr for it:
 *
 * @param slug {string} -- will expect something like: "ca--san-francisco"
 * @param price {string} --
 * @param tags {array} -- will expect an array of EVENTBRITE_CATEGORY_TO_REFINEMENT or EVENTBRITE_FORMAT_TO_REFINEMENT keys
 * @param dates {string} -- will expect an array of the dates expected like: "today" or "tomorrow"
 * @param q {string -- the custom query made.
 *
 * Returns a formatted absolute path with the refinements in place.
 */


var getCanonicalSearchUrl = function getCanonicalSearchUrl(_ref) {
  var slug = _ref.slug,
      price = _ref.price,
      tags = _ref.tags,
      dates = _ref.dates,
      q = _ref.q;
  var refinements = []; // price

  if (price && price === 'free') {
    refinements.push('free');
  } // category & format


  var _parseTagsForUrl2 = _parseTagsForUrl(tags),
      category = _parseTagsForUrl2.category,
      format = _parseTagsForUrl2.format;

  if (category && _constants.EVENTBRITE_CATEGORY_TO_REFINEMENT[category]) {
    refinements.push(_constants.EVENTBRITE_CATEGORY_TO_REFINEMENT[category]);
  }

  if (format && _constants.EVENTBRITE_FORMAT_TO_REFINEMENT[format]) {
    refinements.push(_constants.EVENTBRITE_FORMAT_TO_REFINEMENT[format]);
  } else {
    refinements.push('events');
  } // dates


  var date = _getDateForUrl(dates);

  if (date && _constants.DATES_TO_REFINEMENT[date]) {
    refinements.push(_constants.DATES_TO_REFINEMENT[date]);
  }

  refinements = refinements.join('--'); // query

  var query = _formatNameForUrl(q);

  if (!query) {
    if (refinements === 'events') {
      return "/d/".concat(slug, "/all-events/");
    }

    return "/d/".concat(slug, "/").concat(refinements, "/");
  }

  if (refinements === 'events') {
    return "/d/".concat(slug, "/").concat(query, "/");
  }

  return "/d/".concat(slug, "/").concat(refinements, "/").concat(query, "/");
};

exports.getCanonicalSearchUrl = getCanonicalSearchUrl;
//# sourceMappingURL=url.js.map